import { store, getContext, getElement } from '@wordpress/interactivity';
import GLightbox from 'glightbox';
import Swiper from 'swiper';
import 'swiper/css';

const { state } = store('gt/ctv/hebergement/image', {
    actions: {
        setImages: () => {
            
            const element = getElement();
            const context = getContext();
            const image = element.ref;
        
            if (!image) return;
        
            const loadImage = () => {
                image.setAttribute('src', image.getAttribute('data-gt-src'));
                image.setAttribute('srcset', image.getAttribute('data-gt-srcset'));
                image.setAttribute('sizes', image.getAttribute('data-gt-sizes'));
                if (context.ratio) {
                    image.style.aspectRatio = context.ratio;
                }
            };
        
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadImage();
                        observer.unobserve(image); // stop observing once loaded
                    }
                });
            }, {
                rootMargin: '100px', // pré-chargement avant que ça soit vraiment visible
                threshold: 0.1
            });
        
            observer.observe(image);

            
        },   
        openLightbox: (e) => {
            e.preventDefault();
            const context = getContext();
            let images = [];

            context.images.forEach(url => {
                images.push({
                    'href': url,
                    'type': 'image',
                });
            });

            const image = e.target;
            const clickedIndex = image.getAttribute('src') ? context.images.findIndex(href => href === image.getAttribute('src')) : 0;

            const gallery = GLightbox({
                elements: images,
                loop: true,
                zoomable: true,
                draggable: true,
                preload: true,
                startAt: clickedIndex == -1 ? 0 : clickedIndex,
            });

            gallery.open();
        }
    },
    callbacks:{

        resetSwiper: () => {


            const context = getContext();

            const element = getElement();


            const defaultConfig = {
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 3,
                createElements: true,
                loop: true,
                freemode: true,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    380: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3
                    }
                }
            };

            const jsonConfig =  context.jsonConfig;

            const slider = element.ref ?? document.getElementById(context.sliderId);

            console.log(slider);

            if(!slider){
                return;
            }

            
            if (slider.classList.contains('swiper-initialized')) {
                return;
            }

            const newConfig = { ...defaultConfig, ...jsonConfig };
            let wrapper = slider.querySelector('.swiper-wrapper');
            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.classList.add('swiper-wrapper');
                const children = Array.from(slider.children);
                children.forEach(child => {
                    if (!child.classList.contains('swiper-slide')) {
                        child.classList.remove('swiper-slide');
                    }
                    wrapper.appendChild(child);
                });
                slider.textContent = ''; // Clear slider content safely
                slider.appendChild(wrapper);
            }

            Array.from(wrapper.children).forEach(child => {
                if (!child.classList.contains('swiper-slide')) {
                    child.classList.add('swiper-slide');
                }
            });

            if (wrapper) {
                Array.from(wrapper.children).forEach(child => {
                    if (!child.classList.contains('swiper-slide')) {
                        child.classList.add('swiper-slide');
                    }
                });
            }
            
            const buttonNext = slider.querySelector('.swiper-button-next');
            const buttonPrev = slider.querySelector('.swiper-button-prev');
            
            if (buttonNext) buttonNext.remove();
            if (buttonPrev) buttonPrev.remove();
            const pagination = slider.querySelector('.swiper-pagination');
            if (pagination) {
                pagination.remove();
            }

            const paginationWrapper = document.createElement('div');
            paginationWrapper.classList.add('swiper-pagination');
            slider.appendChild(paginationWrapper);

            const buttonNextWrapper = document.createElement('div');
            buttonNextWrapper.classList.add('swiper-button-next');
            slider.appendChild(buttonNextWrapper);

            const buttonPrevWrapper = document.createElement('div');
            buttonPrevWrapper.classList.add('swiper-button-prev');
            slider.appendChild(buttonPrevWrapper);
                    
        
            const swiperInstance = new Swiper(slider, {
                ...newConfig,
                navigation: {
                    nextEl: buttonNextWrapper,
                    prevEl: buttonPrevWrapper,
                },
                pagination: {
                    el: paginationWrapper,
                    dynamicBullets: true,
                    clickable: true
                },
            });
            swiperInstance.init();

            buttonNextWrapper.addEventListener('click', () => swiperInstance.slideNext());
            buttonPrevWrapper.addEventListener('click', () => swiperInstance.slidePrev());
            

        },
        
    }
});

